import React, { useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode | ((sidebarOpen: boolean) => React.ReactNode);
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleToggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
      }}
    >
      <Header />

      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          mt: '64px', // push below header
        }}
      >
        <Sidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          onToggle={handleToggleSidebar}
        />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            px: isMobile ? 1 : 2,
            py: isMobile ? 1 : 2,

            // LIGHT MODE (unchanged look)
            backgroundColor: '#f5f5f5',

            // 🌙 DARK MODE
            '@media (prefers-color-scheme: dark)': {
              backgroundColor: '#020617',
            },

            overflowY: 'auto',
            height: 'calc(100vh - 64px)',
            transition: 'all 0.2s ease-in-out',
          }}
        >
          {typeof children === 'function' ? children(sidebarOpen) : children}
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};

export default Layout;